import { Component, OnInit } from '@angular/core';
import { Paginacao } from '../../comum/modelos/paginacao';
import { Evento } from '../../comum/eventos/evento';
import { ComumService } from '../../comum/comum.service';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { OcorrenciasService } from '../ocorrencias.service';
import { FiltroOcorrencia } from '../../comum/modelos/filtro-ocorrencia';
import { ResultadoOcorrencias } from '../../comum/modelos/resultado-ocorrencias';
import { Ocorrencia } from '../../comum/modelos/ocorrencia';
import { ConfirmationService } from 'primeng/primeng';
import { CookieService } from 'angular2-cookie/core';
import { PercentualPontoFisico } from '../../comum/modelos/percentual-ponto-fisico';
import { Router } from '@angular/router';
import { Data } from '../../comum/data/data';
import { ResultadoOcorrenciaDiaria } from '../../comum/modelos/resultado-ocorrencia-diaria';
import { PercentualStatus } from '../../comum/modelos/percentual-status';
import { PercentualTipo } from '../../comum/modelos/percentual-tipo';

@Component({
  selector: 'app-visao-geral-ocorrencias',
  templateUrl: './visao-geral-ocorrencias.component.html',
  styleUrls: ['./visao-geral-ocorrencias.component.css']
})
export class VisaoGeralOcorrenciasComponent implements OnInit {
  chartDataOcorrenciasStatus: any[];
  chartDataTipoOcorrencias: any[];
  chartDataOcorrenciasLoja: any[];
  chartDataOcorrenciasDiaria: any[];
  filtroOcorrencia: FiltroOcorrencia;
  resultadoOcorrenciasLoja: ResultadoOcorrencias[];
  resultadoOcorrenciasStatus: ResultadoOcorrencias[];
  resultadoOcorrenciasTipo: ResultadoOcorrencias[];
  resultadoOcorrenciasDiaria: ResultadoOcorrenciaDiaria[];
  ocorrencias: Ocorrencia[];
  percentuaisPontoFisico: PercentualPontoFisico[];
  percentuaisStatus: PercentualStatus[];
  percentuaisTipo: PercentualTipo[];
  view: any[] = [600, 300];
  viewLine: any[] = [1096, 300];
  showLabels = true;
  showLegend = true;
  title: 'Ocorr&ecirc;ncias';
  colorScheme = {
    domain: ['#a8385d', '#7aa3e5', '#a27ea8', '#aae3f5', '#adcded', '#a95963', '#8796c0', '#7ed3ed', '#50abcc', '#ad6886']
  };
  statusCode: number;
  selecionados: boolean;
  public evento: Evento;
  public paginacao: Paginacao;
  public loading = false;
  pt: any;
  dateFormat = 'dd/mm/yy';

  constructor(
    private _comumService: ComumService,
    private _ocorrenciasService: OcorrenciasService,
    private confirmationService: ConfirmationService,
    private _cookieService: CookieService,
    private router: Router,
    private data: Data) {
    this.evento = this._comumService.evento;
    this.paginacao = new Paginacao();
    this.filtroOcorrencia = new FiltroOcorrencia();
    this.chartDataOcorrenciasLoja = new Array<any>();
    this.chartDataOcorrenciasStatus = new Array<any>();
    this.chartDataTipoOcorrencias = new Array<any>();
    this.chartDataOcorrenciasDiaria = new Array<any>();
    this.resultadoOcorrenciasLoja = new Array<ResultadoOcorrencias>();
    this.resultadoOcorrenciasStatus = new Array<ResultadoOcorrencias>();
    this.resultadoOcorrenciasTipo = new Array<ResultadoOcorrencias>();
    this.resultadoOcorrenciasDiaria = new Array<ResultadoOcorrenciaDiaria>();
    this.ocorrencias = new Array<Ocorrencia>();
    this.percentuaisPontoFisico = new Array<PercentualPontoFisico>();
    this.percentuaisStatus = new Array<PercentualStatus>();
    this.percentuaisTipo = new Array<PercentualTipo>();
  }

  ngOnInit() {
    this.paginacao.itens = 5;
    this.paginacao.page = 1;
    const self = this;
    this.filtroOcorrencia.idCliente = parseInt(this._cookieService.get('idCliente'), 10);
    const dataInicio = this._cookieService.get('dataInicioReferencia');
    const dataFim = this._cookieService.get('dataFimReferencia');
    if (dataInicio !== undefined && dataFim !== undefined) {
      this.filtroOcorrencia.dataInicioReferencia = new Date(JSON.parse(dataInicio));
      this.filtroOcorrencia.dataFimReferencia = new Date(JSON.parse(dataFim));

      self.loading = true;
      forkJoin(self._ocorrenciasService.obterOcorrenciasPorPontoFisicoHttp(self.filtroOcorrencia),
        self._ocorrenciasService.obterOcorrenciasPorStatusHttp(self.filtroOcorrencia),
        self._ocorrenciasService.obterOcorrenciasPorTipoHttp(self.filtroOcorrencia),
        self._ocorrenciasService.obterOcorrenciasPorPeriodoHttp(self.filtroOcorrencia),
        self._ocorrenciasService.obterOcorrenciasPorPontoFisicoDiariaHttp(self.filtroOcorrencia))
        .subscribe(([ocorrenciasPorPontoFisico, ocorrenciasPorStatus, ocorrenciasPorTipo, ocorrencias, ocorrenciasDiaria]) => {
          self.resultadoOcorrenciasLoja = ocorrenciasPorPontoFisico.body;
          self.resultadoOcorrenciasLoja.map(function (resultadoOcoLoja) {
            self.chartDataOcorrenciasLoja.push({
              name: resultadoOcoLoja.label,
              value: resultadoOcoLoja.quantidadeOcorrencias
            });
          });
          self.chartDataOcorrenciasLoja = [...self.chartDataOcorrenciasLoja];

          let totalOcorrenciasPontoFisico = 0;
          self.percentuaisPontoFisico = new Array<PercentualPontoFisico>();
          self.resultadoOcorrenciasLoja.forEach(qtd => {
            totalOcorrenciasPontoFisico += qtd.quantidadeOcorrencias;
          });
          self.resultadoOcorrenciasLoja.forEach(ocorrrenciasLoja => {
            const percentualOcorrencia = new PercentualPontoFisico();
            percentualOcorrencia.nomePontoFisico = ocorrrenciasLoja.label;
            percentualOcorrencia.percentual = (ocorrrenciasLoja.quantidadeOcorrencias / totalOcorrenciasPontoFisico) * 100;
            self.percentuaisPontoFisico.push(percentualOcorrencia);
          });

          self.resultadoOcorrenciasStatus = ocorrenciasPorStatus.body;
          self.resultadoOcorrenciasStatus.map(function (resultadoOcoStatus) {
            self.chartDataOcorrenciasStatus.push({
              name: resultadoOcoStatus.label,
              value: resultadoOcoStatus.quantidadeOcorrencias
            });
          });
          self.chartDataOcorrenciasStatus = [...self.chartDataOcorrenciasStatus];

          let totalOcorrenciasStatus = 0;
          self.percentuaisStatus = new Array<PercentualStatus>();
          self.resultadoOcorrenciasStatus.forEach(qtd => {
            totalOcorrenciasStatus += qtd.quantidadeOcorrencias;
          });
          self.resultadoOcorrenciasStatus.forEach(ocorrenciasStatus => {
            const percentualOcorrencia = new PercentualStatus();
            percentualOcorrencia.descricaoStatusOcorrencia = ocorrenciasStatus.label;
            percentualOcorrencia.percentual = (ocorrenciasStatus.quantidadeOcorrencias / totalOcorrenciasStatus) * 100;
            self.percentuaisStatus.push(percentualOcorrencia);
          });

          self.resultadoOcorrenciasTipo = ocorrenciasPorTipo.body;
          self.resultadoOcorrenciasTipo.map(function (resultadoOcoTipo) {
            self.chartDataTipoOcorrencias.push({
              name: resultadoOcoTipo.label,
              value: resultadoOcoTipo.quantidadeOcorrencias
            });
          });
          self.chartDataTipoOcorrencias = [...self.chartDataTipoOcorrencias];

          let totalOcorrenciasTipo = 0;
          self.percentuaisTipo = new Array<PercentualTipo>();
          self.resultadoOcorrenciasTipo.forEach(qtd => {
            totalOcorrenciasTipo += qtd.quantidadeOcorrencias;
          });
          self.resultadoOcorrenciasTipo.forEach(ocorrenciasTipo => {
            const percentualOcorrencia = new PercentualTipo();
            percentualOcorrencia.descricaoTipoOcorrencia = ocorrenciasTipo.label;
            percentualOcorrencia.percentual = (ocorrenciasTipo.quantidadeOcorrencias / totalOcorrenciasTipo) * 100;
            self.percentuaisTipo.push(percentualOcorrencia);
          });

          self.ocorrencias = ocorrencias.body;

          self.resultadoOcorrenciasDiaria = ocorrenciasDiaria.body;
          self.resultadoOcorrenciasDiaria.map(function (resultadoOcorrenciaDiaria) {
            const series = new Array<any>();
            resultadoOcorrenciaDiaria.resultados.map(function (resultadoOcorrencia) {
              series.push({
                name: resultadoOcorrencia.label,
                value: resultadoOcorrencia.quantidadeOcorrencias
              });
            });
            self.chartDataOcorrenciasDiaria.push({
              name: resultadoOcorrenciaDiaria.data,
              series
            });
          });
          self.chartDataOcorrenciasDiaria = [...self.chartDataOcorrenciasDiaria];

          self.loading = false;
        });
    }
    this.pt = {
      firstDayOfWeek: 1,
      dayNames: ['domingo', 'segunda', 'ter\xE7a', 'quarta', 'quinta', 'sexta', 's\xE1bado'],
      dayNamesShort: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 's\xE1b'],
      dayNamesMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
      monthNames: ['janeiro', 'fevereiro', 'mar\xE7o', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro',
        'outubro', 'novembro', 'dezembro'],
      monthNamesShort: ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'],
      today: 'Hoje',
      clear: 'Apagar'
    };
  }

  onSubmit(): void {
    const self = this;
    self.data.storage = {
      'filtroOcorrencia': this.filtroOcorrencia
    };
    if (self.filtroOcorrencia.dataInicioReferencia === undefined || self.filtroOcorrencia.dataFimReferencia === undefined) {
      this.confirmationService.confirm({
        rejectVisible: false,
        message: 'Favor informar ambas as datas para pesquisa',
        accept: () => { },
        reject: () => { }
      });
    } else if (self.filtroOcorrencia.dataInicioReferencia > self.filtroOcorrencia.dataFimReferencia) {
      this.confirmationService.confirm({
        rejectVisible: false,
        message: 'A data final tem de ser maior que a data inicial',
        accept: () => { },
        reject: () => { }
      });
    } else {
      self.loading = true;
      this._cookieService.put('dataInicioReferencia', JSON.stringify(self.filtroOcorrencia.dataInicioReferencia));
      this._cookieService.put('dataFimReferencia', JSON.stringify(self.filtroOcorrencia.dataFimReferencia));
      forkJoin(self._ocorrenciasService.obterOcorrenciasPorPontoFisicoHttp(self.filtroOcorrencia),
        self._ocorrenciasService.obterOcorrenciasPorStatusHttp(self.filtroOcorrencia),
        self._ocorrenciasService.obterOcorrenciasPorTipoHttp(self.filtroOcorrencia),
        self._ocorrenciasService.obterOcorrenciasPorPeriodoHttp(self.filtroOcorrencia),
        self._ocorrenciasService.obterOcorrenciasPorPontoFisicoDiariaHttp(self.filtroOcorrencia))
        .subscribe(([ocorrenciasPorPontoFisico, ocorrenciasPorStatus, ocorrenciasPorTipo, ocorrencias, ocorrenciasDiaria]) => {
          self.resultadoOcorrenciasLoja = ocorrenciasPorPontoFisico.body;
          self.resultadoOcorrenciasLoja.map(function (resultadoOcoLoja) {
            self.chartDataOcorrenciasLoja.push({
              name: resultadoOcoLoja.label,
              value: resultadoOcoLoja.quantidadeOcorrencias
            });
          });
          self.chartDataOcorrenciasLoja = [...self.chartDataOcorrenciasLoja];

          let totalOcorrencias = 0;
          self.percentuaisPontoFisico = new Array<PercentualPontoFisico>();
          self.resultadoOcorrenciasLoja.forEach(qtd => {
            totalOcorrencias += qtd.quantidadeOcorrencias;
          });
          self.resultadoOcorrenciasLoja.forEach(ocorrrenciasLoja => {
            const percentualOcorrencia = new PercentualPontoFisico();
            percentualOcorrencia.nomePontoFisico = ocorrrenciasLoja.label;
            percentualOcorrencia.percentual = (ocorrrenciasLoja.quantidadeOcorrencias / totalOcorrencias) * 100;
            self.percentuaisPontoFisico.push(percentualOcorrencia);
          });

          self.resultadoOcorrenciasStatus = ocorrenciasPorStatus.body;
          self.resultadoOcorrenciasStatus.map(function (resultadoOcoStatus) {
            self.chartDataOcorrenciasStatus.push({
              name: resultadoOcoStatus.label,
              value: resultadoOcoStatus.quantidadeOcorrencias
            });
          });
          self.chartDataOcorrenciasStatus = [...self.chartDataOcorrenciasStatus];

          let totalOcorrenciasStatus = 0;
          self.percentuaisStatus = new Array<PercentualStatus>();
          self.resultadoOcorrenciasStatus.forEach(qtd => {
            totalOcorrenciasStatus += qtd.quantidadeOcorrencias;
          });
          self.resultadoOcorrenciasStatus.forEach(ocorrenciasStatus => {
            const percentualOcorrencia = new PercentualStatus();
            percentualOcorrencia.descricaoStatusOcorrencia = ocorrenciasStatus.label;
            percentualOcorrencia.percentual = (ocorrenciasStatus.quantidadeOcorrencias / totalOcorrenciasStatus) * 100;
            self.percentuaisStatus.push(percentualOcorrencia);
          });

          self.resultadoOcorrenciasTipo = ocorrenciasPorTipo.body;
          self.resultadoOcorrenciasTipo.map(function (resultadoOcoTipo) {
            self.chartDataTipoOcorrencias.push({
              name: resultadoOcoTipo.label,
              value: resultadoOcoTipo.quantidadeOcorrencias
            });
          });
          self.chartDataTipoOcorrencias = [...self.chartDataTipoOcorrencias];

          let totalOcorrenciasTipo = 0;
          self.percentuaisTipo = new Array<PercentualTipo>();
          self.resultadoOcorrenciasTipo.forEach(qtd => {
            totalOcorrenciasTipo += qtd.quantidadeOcorrencias;
          });
          self.resultadoOcorrenciasTipo.forEach(ocorrenciasTipo => {
            const percentualOcorrencia = new PercentualTipo();
            percentualOcorrencia.descricaoTipoOcorrencia = ocorrenciasTipo.label;
            percentualOcorrencia.percentual = (ocorrenciasTipo.quantidadeOcorrencias / totalOcorrenciasTipo) * 100;
            self.percentuaisTipo.push(percentualOcorrencia);
          });

          self.ocorrencias = ocorrencias.body;

          self.resultadoOcorrenciasDiaria = ocorrenciasDiaria.body;
          self.resultadoOcorrenciasDiaria.map(function (resultadoOcorrenciaDiaria) {
            const series = new Array<any>();
            resultadoOcorrenciaDiaria.resultados.map(function (resultadoOcorrencia) {
              series.push({
                name: resultadoOcorrencia.label,
                value: resultadoOcorrencia.quantidadeOcorrencias
              });
            });
            self.chartDataOcorrenciasDiaria.push({
              name: resultadoOcorrenciaDiaria.data,
              series
            });
          });
          self.chartDataOcorrenciasDiaria = [...self.chartDataOcorrenciasDiaria];

          self.loading = false;
        });
    }
  }

  buscarOcorrenciasPontoFisicoGrafico(event: any) {
    this.filtroOcorrencia.nomePontoFisico = event.name;
    this.filtroOcorrencia.origem = 'PONTO-FISICO';
    this.data.storage = {
      'filtroOcorrencia': this.filtroOcorrencia
    };
    this.router.navigate(['listar-ocorrencias-grafico', 'PONTO-FISICO']);
    this.loading = false;
  }

  buscarOcorrenciasStatusGrafico(event: any) {
    this.filtroOcorrencia.descricaoStatusOcorrencia = event.name;
    this.filtroOcorrencia.origem = 'STATUS';
    this.data.storage = {
      'filtroOcorrencia': this.filtroOcorrencia
    };
    this.router.navigate(['listar-ocorrencias-grafico', 'STATUS']);
    this.loading = false;
  }

  buscarOcorrenciasTipoGrafico(event: any) {
    this.filtroOcorrencia.descricaoTipoOcorrencia = event.name;
    this.filtroOcorrencia.origem = 'TIPO';
    this.data.storage = {
      'filtroOcorrencia': this.filtroOcorrencia
    };
    this.router.navigate(['listar-ocorrencias-grafico', 'TIPO']);
    this.loading = false;
  }

  buscarOcorrenciasDiariaGrafico(event: any) {
    this.filtroOcorrencia.nomePontoFisico = event.name;
    const year = event.series.substr(6, 4);
    const month = event.series.substr(3, 2) - 1;
    const day = event.series.substr(0, 2);
    this.filtroOcorrencia.diaOcorrencia = new Date(year, month, day);
    this.filtroOcorrencia.origem = 'DIARIA';
    this.data.storage = {
      'filtroOcorrencia': this.filtroOcorrencia
    };
    this.router.navigate(['listar-ocorrencias-grafico', 'DIARIA']);
    this.loading = false;
  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/ocorrencias/visao-geral-ocorrencias/visao-geral-ocorrencias.component.ts